const doc = [({"ja":({"adminConstantHotelPlanType":({"normal":"ノーマル", "secret":"シークレット"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;